import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import "./ProductDetail.css";

function Carousel({ images, video, name }) {
  const slides = [
    ...images.map((src) => ({ type: "image", src })),
    ...(video ? [{ type: "video", src: video }] : []),
  ];
  const [current, setCurrent] = useState(0);
  const slide = slides[current];

  return (
    <div className="carousel">
      <div className="carousel-thumbs">
        {slides.map((s, i) =>
          s.type === "video" ? (
            <div
              key={i}
              className={`carousel-thumb video-thumb ${i === current ? "active" : ""}`}
              onClick={() => setCurrent(i)}
              aria-label="Ver vídeo"
            >
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                width="20"
                height="20"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
          ) : (
            <img
              key={i}
              src={s.src}
              alt={`${name} ${i + 1}`}
              className={`carousel-thumb ${i === current ? "active" : ""}`}
              onClick={() => setCurrent(i)}
            />
          ),
        )}
      </div>

      <div className="carousel-main">
        <button
          className="carousel-arrow left"
          onClick={() =>
            setCurrent((c) => (c === 0 ? slides.length - 1 : c - 1))
          }
          aria-label="Anterior"
        >
          &#8249;
        </button>
        {slide.type === "video" ? (
          <video
            key={slide.src}
            className="carousel-img"
            controls
            playsInline
            muted
            autoPlay
            loop
          >
            <source src={slide.src} />
          </video>
        ) : (
          <img
            src={slide.src}
            alt={`${name} ${current + 1}`}
            className="carousel-img"
          />
        )}
        <button
          className="carousel-arrow right"
          onClick={() =>
            setCurrent((c) => (c === slides.length - 1 ? 0 : c + 1))
          }
          aria-label="Siguiente"
        >
          &#8250;
        </button>
      </div>
    </div>
  );
}

function BenefitItem({ text }) {
  const colonIdx = text.indexOf(":");
  if (colonIdx === -1) return <li>{text}</li>;
  const label = text.slice(0, colonIdx);
  const body = text.slice(colonIdx + 1).trim();
  return (
    <li>
      <span className="benefit-label">{label}:</span> {body}
    </li>
  );
}

function ProductDetail() {
  const { id } = useParams();

  const products = [
    {
      id: 1,
      amazonUrl: "https://amzn.eu/d/06S22omt",
      name: "Separador Dedos Pie de Silicona con Protector de Juanetes",
      images: [
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692447/1_separador.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692443/2_separador.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692443/3_separador.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692446/4_separador.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692445/5_separador.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692445/6_separador.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692444/7_separador.jpg",
      ],
      video: "https://res.cloudinary.com/dozvtnkeb/video/upload/v1774697794/SEPARADORES_DE_DEDOS_qmdghs.mp4",
      description:
        "Adecuado para utilizar dentro de calcetines y todo tipo de zapatos. Almohadillas para pies de gel con alivio del dolor metatarsiano.",
      benefits: [
        "ALIVIA LA METATARSALGIA: Amortiguación uniforme de la articulación metatarsiana, aliviando molestias y ofreciendo soporte en toda la bola del pie.",
        "RELAJA LOS PIES: Disminuye la fricción entre dedos, promueve la circulación sanguínea y reduce la presión en el antepié.",
        "COMODIDAD Y SUAVIDAD: El gel ultrasuave permite usarlo cómodamente en cualquier calzado sin que nadie lo note.",
        "ALTA CALIDAD: Fabricado en silicona de alta calidad con almohadillas de gel duradero.",
        "LAVABLE: No coge mal olor gracias a su gran transpirabilidad. Se limpia fácilmente con agua tibia y jabón.",
      ],
      specs: [
        "Material: silicona de alta calidad",
        "Almohadillas: gel duradero y transpirable",
        "Apto para uso dentro de calcetines",
        "Compatible con todo tipo de calzado",
        "Lavable y reutilizable",
      ],
      usage:
        "Colocar el separador entre los dedos del pie antes de calzarse. Puede usarse directamente dentro del calcetín. Lavar con agua tibia y jabón tras cada uso.",
    },
    {
      id: 2,
      amazonUrl: "https://amzn.eu/d/0eV46NaT",
      name: "Faja Lumbar Hombre y Mujer con Soporte de Aluminio y Placa de Apoyo",
      images: [
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692426/1_faja.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692409/2_faja.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692409/3_faja.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692408/4_faja.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692408/5_faja.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692409/6_faja.jpg",
      ],
      video: "https://res.cloudinary.com/dozvtnkeb/video/upload/v1774697823/FAJA_lm6k3m.mp4",
      description:
        "Faja lumbar con doble ajuste y presión abdominal. Alivia la ciática y el dolor de espalda manteniéndote activo con seguridad y confort.",
      benefits: [
        "ESTABILIZA EL LUMBOSACRO: Sus dos placas de aluminio mantienen la columna vertebral y lumbares estables, permitiendo realizar actividades diarias, deportivas y laborales con seguridad.",
        "ALIVIA DOLORES DE CINTURA: Las dos placas de protección se ajustan a la cintura aliviando dolores en la zona baja de la espalda y ayudando a mantener una postura correcta sin reducir la libertad de movimiento.",
        "SOPORTE ABDOMINAL: Sistema de banda elástica transversal con doble ajuste que estabiliza la cintura y el abdomen, relajando la presión sobre la columna de manera uniforme.",
        "CÓMODA Y LIGERA: Cierre de velcro resistente, bordes de lycra suave y material de neopreno transpirable protegen la espalda sin perder calidad de vida.",
        "CALIDAD Y VERSATILIDAD: Fabricada en neopreno y nylon de alta calidad. Apta para tareas domésticas, levantar peso, deporte, oficina, conducción y mucho más.",
      ],
      specs: [
        "Material: neopreno y nylon de alta calidad",
        "2 placas internas de aluminio",
        "Cierre de velcro resistente",
        "Bordes de lycra suave",
        "Banda elástica transversal con doble ajuste",
        "Material transpirable",
      ],
      usage:
        "Ajustar la faja alrededor de la cintura con el velcro hasta obtener la compresión deseada. La banda elástica transversal puede ajustarse de forma independiente para mayor soporte abdominal. Apta para uso continuo durante actividad física o jornada laboral.",
    },
    {
      id: 3,
      amazonUrl: "https://amzn.eu/d/06lPx16X",
      name: "Coderas Epicondilitis con Almohadilla de Silicona Masajeadora",
      images: [
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692386/1_codera.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692385/2_codera.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692385/3_codera.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692386/4_codera.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692385/5_codera.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774692385/6_codera.jpg",
      ],
      video: "https://res.cloudinary.com/dozvtnkeb/video/upload/v1774697839/CODERA_V2_qquevo.mp4",
      description:
        "Pack de 2 unidades. Tejido 3D transpirable para tendinitis, codo de tenista. Protege en el pádel, crossfit y gym.",
      benefits: [
        "EFECTO MASAJEADOR: Cuando el brazo se mueve, la almohadilla y el tejido 3D masajean los ligamentos y músculos del codo, estimulando la circulación y disminuyendo la hinchazón por epicondilitis, tendinitis y codo golfista.",
        "ALIVIO AL DOLOR: Ofrecen soporte, compresión y protección contra impactos. Calientan el codo durante el ejercicio, mejoran la flexibilidad y aceleran la recuperación de lesiones.",
        "PROTECCIÓN Y COMODIDAD: Almohadilla de silicona protectora junto al tejido de punto sin costuras que reduce la fricción en codo y antebrazo durante todo el entrenamiento.",
        "LIBERTAD DE MOVIMIENTO: Combinación de neopreno y nylon con diseño anatómico que se adapta al brazo y mantiene una presión equilibrada en toda la articulación.",
        "TRANSPIRABLE: Tela transpirable y suave que evita la acumulación de sudor. Lavable a máquina a 30 °C, sin suavizantes, secar al aire.",
      ],
      specs: [
        "Pack de 2 unidades",
        "Material: neopreno, nylon y tejido 3D transpirable",
        "Almohadilla de silicona masajeadora",
        "Tejido de punto sin costuras",
        "Apta para brazo izquierdo y derecho",
        "Lavable a máquina a 30 °C",
      ],
      usage:
        "Colocar la codera en el antebrazo, posicionando la almohadilla de silicona sobre la zona dolorida. Ajustar la compresión según necesidad. Apta para uso en deporte y actividad diaria.",
    },
    {
      id: 4,
      amazonUrl: "https://amzn.eu/d/0ewOkUK1",
      name: "Tobillera para Esguince Hombre y Mujer",
      images: [
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774693103/1_tobillera.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774693362/2_tobillera.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774693363/3_tobilleraf.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774693365/4_tobillera.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774693366/5_tobillera.jpg",
        "https://res.cloudinary.com/dozvtnkeb/image/upload/v1774693368/6_tobillera.jpg",
      ],
      video: "https://res.cloudinary.com/dozvtnkeb/video/upload/v1774697764/Tobillera_1_m5d94m.mp4",
      description:
        "Con placas de soporte de PVC y bandas de compresión ajustable. Para deportes y exterior con protección contra impactos, apta para llevar con zapatos.",
      benefits: [
        "MIDE TU TOBILLO ANTES DE COMPRAR: Recomendada para tobillos entre 24 y 30 cm. Medir correctamente garantiza un ajuste adecuado, mayor estabilidad y mejor experiencia de uso.",
        "TOBILLERA ESTABILIZADORA CON SOPORTE LATERAL REFORZADO: Incorpora placas de PVC y compresión ajustable para máxima estabilidad. Ideal para deporte, caminar, entrenar o actividades diarias que requieren mayor control del movimiento.",
        "COMPRESIÓN AJUSTABLE CON VELCRO DE ALTA RESISTENCIA: Permite regular fácilmente el nivel de compresión. Se adapta al pie izquierdo y derecho, funcionando como soporte firme y cómodo.",
        "CÓMODA, TRANSPIRABLE Y APTA PARA USO CON CALZADO: Materiales ligeros y transpirables que permiten usarla con zapatillas deportivas o calcetines sin molestias.",
        "SOPORTE Y ESTABILIDAD PARA MAYOR SEGURIDAD: Compresión ajustable y soporte lateral que mejora la estabilidad durante la actividad física. Perfecta para protección, recuperación y uso diario.",
      ],
      specs: [
        "Talla recomendada: circunferencia de tobillo entre 24 y 30 cm",
        "Placas de soporte de PVC",
        "Sistema de velcro de alta resistencia",
        "Materiales ligeros y transpirables",
        "Apta para pie izquierdo y derecho",
        "Compatible con calzado deportivo",
      ],
      usage:
        "Medir la circunferencia del tobillo antes de usar. Colocar la tobillera sobre el pie y ajustar las bandas de velcro hasta conseguir la compresión deseada. Puede usarse con calcetines y dentro del calzado habitual.",
    },
  ];

  const product = products.find((p) => p.id === parseInt(id));

  if (!product) {
    return (
      <div className="product-not-found">
        <h2>Producto no encontrado</h2>
        <Link to="/productos" className="back-btn">
          Ver todos los productos
        </Link>
      </div>
    );
  }

  return (
    <div className="product-detail">
      <div className="pd-breadcrumb">
        <Link to="/productos">← Todos los productos</Link>
      </div>

      <div className="product-detail-container">
        <div className="product-image-section">
          <Carousel
            images={product.images}
            video={product.video}
            name={product.name}
          />
        </div>

        <div className="product-info-section">
          <h1>{product.name}</h1>
          <p className="pd-description">{product.description}</p>

          <a
            href={product.amazonUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="pd-amazon-btn"
          >
            Comprar en Amazon
          </a>

          <div className="pd-divider" />

          <div className="pd-section">
            <h2>Características</h2>
            <ul className="pd-benefits">
              {product.benefits.map((b, i) => (
                <BenefitItem key={i} text={b} />
              ))}
            </ul>
          </div>

          <div className="pd-divider" />

          <div className="pd-section">
            <h2>Especificaciones</h2>
            <ul className="pd-specs">
              {product.specs.map((s, i) => (
                <li key={i}>{s}</li>
              ))}
            </ul>
          </div>

          <div className="pd-divider" />

          <div className="pd-section">
            <h2>Modo de uso</h2>
            <p className="pd-usage">{product.usage}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductDetail;
